var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notes)?_c('div',{staticClass:"flex flex-row space-x-2"},[_c('div',{staticClass:"flex items-start justify-center flex-shrink-0 w-5"},[_c('icon-event-note',{staticClass:"w-4 h-4 font-black text-center",class:{
        'text-brand-lightblue': _vm.isCheckedIn || !_vm.eventIsPast,
        'text-gray-400': _vm.eventIsPast && !_vm.isCheckedIn
      }})],1),_c('div',{staticClass:"flex-1 inline-block p-0 text-sm leading-4"},[_vm._v(" "+_vm._s(_vm.notes)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }